module.exports = __webpack_public_path__ + "static/media/trainingBehaviorIcon.5e45e8d1.png";